/**
 * Chaves alinhadas ao painel (Dashboard.js) e à política no backend (permission_templates / xui_group_permissions).
 */
export const DASHBOARD_CARD_DEFS = [
  ['quickTest', 'Teste Servidor'],
  ['kpi', 'Cartões KPI (Clientes, Atendimentos, Receita, Leads)'],
  ['sigmaRow', 'Atividade, novos contatos e vendas canceladas'],
  ['growth', 'Gráfico de tendência (24h / 7d / 30d)'],
  ['infra', 'Infra — servidores SSH'],
  ['funnel', 'CRM — funil de vendas'],
  ['iptv', 'IPTV — catálogo ativo'],
  ['ranking', 'Liga da semana — ranking de revendas'],
  ['quickActions', 'Acesso rápido'],
  ['tmdbReleases', 'Lançamentos — filmes e séries (Servidor)'],
];

/** Default: todos os cards visíveis. O admin pode ocultar nas Permissões. */
export function defaultDashboardCards() {
  return Object.fromEntries(DASHBOARD_CARD_DEFS.map(([k]) => [k, true]));
}

/** Mescla resposta parcial do servidor; chaves desconhecidas ignoradas. */
export function mergeDashboardCards(raw) {
  const d = defaultDashboardCards();
  if (raw && typeof raw === 'object') {
    for (const key of Object.keys(d)) {
      if (Object.prototype.hasOwnProperty.call(raw, key)) d[key] = !!raw[key];
    }
  }
  return d;
}
